import { Injectable } from '@angular/core';
import {
  APIResponse,
  Company,
  Currency,
  GeoCity,
  GeoCountry,
  Role,
  Timezone,
  User,
  CompanyPublic,
} from '@macs-frontend/web-macs/shared';
import { Observable } from 'rxjs';
import { ApiService } from '..';
import { UUID } from '../utils/uuid';

@Injectable({
  providedIn: 'root',
})
export class MetaService extends ApiService {
  loadCurrencies(): Observable<APIResponse<Currency[]>> {
    return this.http.get(`${this.API_PATH}/control_center/currencies`) as Observable<
      APIResponse<Currency[]>
    >;
  }

  loadLanguages(): Observable<APIResponse<string[]>> {
    return this.http.get(`${this.API_PATH}/languages`) as Observable<
      APIResponse<string[]>
    >;
  }

  loadTimezones(): Observable<APIResponse<Timezone[]>> {
    return this.http.get(`${this.API_PATH.replace('v1', 'v2')}/timezones`) as Observable<
      APIResponse<Timezone[]>
    >;
  }

  loadCurrentCompany(): Observable<APIResponse<Company>> {
    return this.http.get(
      `${this.API_PATH}/company_manangement/manage/companies/current`,
    ) as Observable<APIResponse<Company>>;
  }

  loadCurrentUser(): Observable<APIResponse<User>> {
    return this.http.get(`${this.API_PATH}/control_center/users/current`) as Observable<
      APIResponse<User>
    >;
  }

  loadRoleUnits(): Observable<APIResponse<Role[]>> {
    return this.http.get(`${this.API_PATH}/control_center/roles`) as Observable<
      APIResponse<Role[]>
    >;
  }

  saveRoleUnit(roleUnitId: UUID, roleUnit: any): Observable<APIResponse<Role>> {
    return this.http.patch(`${this.API_PATH}/control_center/roles/${roleUnitId}`, {
      ...roleUnit,
    }) as Observable<APIResponse<Role>>;
  }

  changeCurrentCompany(companyId: UUID): Observable<{ token: string }> {
    return this.http.patch(
      `${this.API_PATH}/control_center/users/company/${companyId}`,
      null,
    ) as Observable<{ token: string }>;
  }

  loadCurrentPublicCompany(): Observable<APIResponse<CompanyPublic>> {
    return this.http.get(`${this.API_PATH}/public/company/current`) as Observable<
      APIResponse<CompanyPublic>
    >;
  }

  loadGeoCities(payload: {
    search: string;
    page: number;
    limit: number;
    nameUtf8: string;
  }) {
    return this.http.get(
      `${this.API_PATH}/geo/cities?${this.stringify(payload)}`,
    ) as Observable<APIResponse<GeoCity[]>>;
  }

  loadGeoCountries(payload: {
    search: string;
    page: number;
    limit: number;
    name: string;
    domain: string;
    code: string;
  }) {
    return this.http.get(
      `${this.API_PATH}/api/v1/geo/countries?${this.stringify(payload)}`,
    ) as Observable<APIResponse<GeoCountry[]>>;
  }
}
